import { firestore, storage } from '../Firebase';
import Firebase from 'firebase/app';

import { setCompleted, setTotal, showSnackbarAction,setconstants, setUserPreference ,setOrganizationResources, setMBConstants} from '../Redux/actions';
import moment from 'moment';
import {
  CompletedTaskValidation,
  OverdueTaskValidation,
  PendingTaskValidation,
} from './validation';
import { chunk, properFormat,uploadFileToS3 } from '../Values/utils';
import axios from "axios";
import {url} from "../../src/Values/constants";
import axiosHandler from './axiosHandler';
import { leadSource } from '../Values/tables';


export const SaveData = async (
  authToken?:any,
  user?:any,
  selectedRows?: any[],
  panel?:any,
  data?:any
) => {
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken
    let res = await axiosHandler.post(url+'/auditLogs/createExportLogs', {
    uid:user.uid?user.uid:"",
    user_email:user.user_email?user.user_email:"",
    user_first_name:user.user_first_name?user.user_first_name:"",
    user_last_name:user.user_last_name?user.user_last_name:"",
    total_count:selectedRows?.length?selectedRows?.length:"1",
    type:panel?panel:"",
    organization_id:user.organization_id?user.organization_id:"",
    operation_type:"Delete",
    description:data?data:""
    })
    console.log("Delete Log Saved Successfully");
  } catch (error) {
    console.log(error,"Delete Log Couldn't Be Saved");
  }
}

const sanitizeFileName = (fileName:any) => {
  // Remove control characters, special characters, and Unicode characters
  const sanitizedFileName = fileName.replace(/[^\w.]/g, "");
  // Limit filename length
  return sanitizedFileName.substring(0, 254); // Maximum length of 255 characters
};

const getFileExtension = (fileName: string): string => {
  const parts:any= fileName.split(".");
  if (parts.length > 2) {
    return ''; // If there are multiple periods, return an empty string to indicate an invalid extension
  }
  return parts.pop().toLowerCase();
};

const allowedExtensions = [
  "csv",
  "jpg",
  "jpeg",
  "png",
  "pdf",
  "doc",
  "docx",
  "mp3",
  "mp4",
  "mpeg",
  "m4a",
  "wav",
  "aac"
];

export const uploadCarouselImages = async (
  imageList: any,
  organization_id: string,
  authToken:any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void,
  user:any
) => {
 try{
  var carouselList: any[] = [];
  for await (const result of Array.from(imageList).map(async (item: any) => {
    console.log(`Uploading file: ${item.name}, Size: ${item.size} bytes`);
     
    const validFileName = sanitizeFileName(item.name);
    const maxFileSize = 100 * 1024 * 1024; // 100 MB

    // File extension check
    const fileExtension = getFileExtension(validFileName);
    if (!fileExtension || !allowedExtensions.includes(fileExtension.toLowerCase())) {
      dispatcher(showSnackbarAction("Invalid file extension", 'error'));
      setLoad(false)
      close();
      return;
    }
    
    if (item.size > maxFileSize) {
      dispatcher(showSnackbarAction("File size is too large, It should be less than 100 MB", 'error'));
      setLoad(false)
      close();
      return;
    }
    let url = await uploadFileToS3(item,`${organization_id}/Resources`);
    carouselList.push({
      url:url,
      // created_at: Firebase.firestore.Timestamp.now(),
      imageType:"IMAGE",
      modified_by:user.uid,
      imageName: item.name,
    });
    return true;
  })) {
    if (result) {
      createResourceMongo(organization_id,"carousel", carouselList, dispatcher, setLoad, close,authToken);
    }
  }
 }catch(error:any){
  dispatcher(showSnackbarAction(error.response.data.message, 'error'));
  setLoad(false);
 }
};

export const uploadLogoImages = async (
  imageList: any,
  organization_id: string,
  authToken:string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void,
  user:any
) => {
  try{
    var logoList: any[] = [];
  for await (const result of Array.from(imageList).map(async (item: any) => {
    let url = await uploadFileToS3(item,`${organization_id}/Resources`);
    logoList.push({
      url:url,
      // created_at: Firebase.firestore.Timestamp.now(),
      imageType:"LOGO",
      modified_by:user.uid,
      imageName: item.name,
    });
    return true;
  })) {
    if (result) {
      createResourceMongo(organization_id,"carousel", logoList, dispatcher, setLoad, close,authToken);
    }
  }
  }
  catch(error:any){
    dispatcher(showSnackbarAction(error.response.data.message, 'error'));
    setLoad(false);
   }
};

const createCarousel = (
  organization_id: string,
  carouselList: any[],
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        carousel: Firebase.firestore.FieldValue.arrayUnion(...carouselList),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Carousel Updated!', 'success'));
      setLoad(false);
      close();
    })
    .catch((error) => {
      console.log('Carousel Error', error);
      dispatcher(showSnackbarAction('Error!Try Again', 'error'));
      setLoad(false);
    });
};

const createLogo = (
  organization_id: string,
  logoList: any[],
  dispatcher: any,
  setLoad: (data: boolean) => void,
  close: () => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        logoList:logoList
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Logo Updated!', 'success'));
      setLoad(false);
      close();
    })
    .catch((error) => {
      console.log('Carousel Error', error);
      dispatcher(showSnackbarAction('Error!Try Again', 'error'));
      setLoad(false);
    });
};

export const fetchResources = (
  setLocations: (data: any[]) => void,
  setBudgets: (data: any[]) => void,
  setCarousel: (data: any[]) => void,
  setLeadSource: (data: any[]) => void,
  setComType: (data: any[]) => void,
  setResType: (data: any[]) => void,
  organization_id: string,
  setTransferReasons?: (data: any[]) => void,
  setLogoList?: (data: any[]) => void,
  setBusinessVerticalList?: (data: any[]) => void,
  setFormNamesList?: (data: any[]) => void,
  setState?: (data: any[]) => void,
  setIndustrialTypes?: (data: any[]) => void,
  setInstitutionalTypes?: (data: any[]) => void,
) => {
  const subscriber = firestore
    .collection('organizationResources')
    .doc(organization_id)
    .onSnapshot((resources) => {
      if (resources) {
        const resourceData = resources.data();
        if (resourceData?.locations) {
          setLocations(resourceData?.locations);
        } else {
          setLocations([]);
        }
        if (resourceData?.budgets) {
          setBudgets(resourceData?.budgets);
        } else {
          setBudgets([]);
        }
        if (resourceData?.leadSources) {
          setLeadSource(resourceData?.leadSources);
        } else {
          setLeadSource([]);
        }
        if (resourceData?.carousel) {
          setCarousel(resourceData?.carousel);
        } else {
          setCarousel([]);
        }
        if (resourceData?.comTypes) {
          setComType(resourceData?.comTypes);
        } else {
          setComType([]);
        }
        if (resourceData?.resTypes) {
          setResType(resourceData?.resTypes);
        } else {
          setResType([]);
        }
        if (resourceData?.TransferReasons) {
          setTransferReasons &&
            setTransferReasons(resourceData?.TransferReasons);
        } else {
          setTransferReasons && setTransferReasons([]);
        }
        if (resourceData?.logoList) {
          setLogoList && setLogoList(resourceData?.logoList);
        } else {
          setLogoList && setLogoList([]);
        }
        if (resourceData?.businessVertical) {
          setBusinessVerticalList && setBusinessVerticalList(resourceData?.businessVertical);
        } else {
          setBusinessVerticalList && setBusinessVerticalList([]);
        }
        if (resourceData?.apiForms) {
          setFormNamesList && setFormNamesList(resourceData?.apiForms);
        } else {
          setFormNamesList && setFormNamesList([]);
        }
        if (resourceData?.state) {
          setState && setState(resourceData?.state);
        } else {
          setState && setState([]);
        }
        if (resourceData?.institutionalType) {
          setInstitutionalTypes && setInstitutionalTypes(resourceData?.institutionalType);
        } else {
          setInstitutionalTypes && setInstitutionalTypes([]);
        }
        if (resourceData?.industrialType) {
          setIndustrialTypes && setIndustrialTypes(resourceData?.industrialType);
        } else {
          setIndustrialTypes && setIndustrialTypes([]);
        }
        // if (resourceData?.templates) {
        //   setTemplates && setTemplates(resourceData?.templates);
        // } else {
        //   setTemplates && setTemplates([]);
        // }
      } else {
        console.log('Org not found');
      }
    });
  return subscriber;
};

export const createLocation = (
  organization_id: string,
  location_name: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        locations: Firebase.firestore.FieldValue.arrayUnion({
          location_name: location_name,
          created_at: Firebase.firestore.Timestamp.now(),
        }),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Location Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Location Error', error);
      setLoad(false);
    });
};

export const createCustomTemplate = async (
  organization_id: string,
  value: string,
  dispatcher: any,
  history: any,
  setLoading: (data: boolean) => void,
  custom_template:any,
  user:any,
  authToken:any
) => {
  setLoading(true);
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken
    // let res = await axios.post(url+'/organizationResources/add', {
    //   organization_id:organization_id,
      const data = [{
        template_name : value,
        template_data : custom_template,
        modified_by  :user.uid,
      }]     
    // })

    createResourceMongo(organization_id,"custom_templates",data,dispatcher,setLoading,()=>{},authToken)
    // dispatcher(showSnackbarAction('Template Added Successfully', 'success'));
    // setLoading(false); 
    // window.location.reload()
  } catch (error) {
    dispatcher(
      showSnackbarAction(
        "Template Error",
        'error'
      )
    );
    setLoading(false);
  }
   
};

export const createBudget = (
  organization_id: string,
  budget: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        budgets: Firebase.firestore.FieldValue.arrayUnion({
          budget: budget,
          created_at: Firebase.firestore.Timestamp.now(),
        }),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Budget Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Budget Error', error);
      setLoad(false);
    });
};

export const createLeadSource = (
  organization_id: string,
  leadSource: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        leadSources: Firebase.firestore.FieldValue.arrayUnion({
          leadSource: leadSource,
          created_at: Firebase.firestore.Timestamp.now(),
        }),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Lead Source Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Lead Source Error', error);
      setLoad(false);
    });
};

export const deleteProjectImage = async (
  type: string,
  imageList: any[] | undefined,
  project_id: any,
  index: number,
  fileName: string,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} image from ${project_name} project from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//       // dispatcher(
//       //   showSnackbarAction(
//       //     res.data.message,
//       //     'success'
//       //   )
//       // );
//     } catch (error) {
//       // dispatcher(
//       //   showSnackbarAction(
//       //     "OTP Verification Failed ! Please try again",
//       //     'error'
//       //   )
//       // );
//     }
// }
  const path = `project/${project_id}/${type}/${fileName}`;
  const reference = storage.ref(path);
  imageList?.splice(index, 1);
  try {
    await firestore.collection('projectResources').doc(project_id).set(
      {
        images: imageList,
      },
      { merge: true }
    );
    await reference.delete();
    dispatcher(showSnackbarAction('Image Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} image from ${project_name} project from ${panel?panel:""} panel.`)
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};

export const deleteProjectVideo = async (
  type: string,
  videoList: any[] | undefined,
  project_id: any,
  index: number,
  fileName: string,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} video from ${project_name} project from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  const path = `project/${project_id}/${type}/${fileName}`;
  const reference = storage.ref(path);
  videoList?.splice(index, 1);
  try {
    await firestore.collection('projectResources').doc(project_id).set(
      {
        video: videoList,
      },
      { merge: true }
    );

    await reference.delete();
    dispatcher(showSnackbarAction('Video Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} video from ${project_name} project from ${panel?panel:""} panel.`)
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};

export const deleteProjectBrochures = async (
  type: string,
  brochuresList: any[] | undefined,
  project_id: any,
  index: number,
  fileName: string,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} brochure from ${project_name} project from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  const path = `project/${project_id}/${type}/${fileName}`;
  const reference = storage.ref(path);
  brochuresList?.splice(index, 1);
  try {
    await firestore.collection('projectResources').doc(project_id).set(
      {
        brochures: brochuresList,
      },
      { merge: true }
    );

    await reference.delete();
    dispatcher(showSnackbarAction('brochure Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} brochure from ${project_name} project from ${panel?panel:""} panel.`)
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};
export const deleteProjectPriceLists = async (
  type: string,
  priceList: any[] | undefined,
  project_id: any,
  index: number,
  fileName: string,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} price list from ${project_name} project from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  const path = `project/${project_id}/${type}/${fileName}`;
  const reference = storage.ref(path);
  priceList?.splice(index, 1);
  try {
    await firestore.collection('projectResources').doc(project_id).set(
      {
        priceLists: priceList,
      },
      { merge: true }
    );

    await reference.delete();
    dispatcher(showSnackbarAction('priceList Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} price list from ${project_name} project from ${panel?panel:""} panel.`)
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};
export const deleteProjectLayouts = async (
  type: string,
  layoutList: any[] | undefined,
  project_id: any,
  index: number,
  fileName: string,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} layout from ${project_name} project from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  const path = `project/${project_id}/${type}/${fileName}`;
  const reference = storage.ref(path);
  layoutList?.splice(index, 1);
  try {
    await firestore.collection('projectResources').doc(project_id).set(
      {
        layouts: layoutList,
      },
      { merge: true }
    );

    await reference.delete();
    dispatcher(showSnackbarAction('layout Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} layout from ${project_name} project from ${panel?panel:""} panel.`)
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};

export const deleteProjectForms = async (
  type: string,
  formList: any[] | undefined,
  project_id: any,
  index: number,
  fileName: string,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} form from ${project_name} project from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  const path = `project/${project_id}/${type}/${fileName}`;
  const reference = storage.ref(path);
  formList?.splice(index, 1);
  try {
    await firestore.collection('projectResources').doc(project_id).set(
      {
        forms: formList,
      },
      { merge: true }
    );

    await reference.delete();
    dispatcher(showSnackbarAction('Form Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${fileName?fileName:""} form from ${project_name} project from ${panel?panel:""} panel.`)
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};

export const deleteCarouselImage = async (
  organization_id: string,
  image_name: string,
  carouselList: any[],
  index: number,
  dispatcher: any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${image_name?image_name:""} image from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  const path = `carousel/${organization_id}/${image_name}`;
  const reference = storage.ref(path);
  carouselList.splice(index, 1);
  try {
    await firestore
      .collection('organizationResources')
      .doc(organization_id)
      .set(
        {
          carousel: carouselList,
        },
        { merge: true }
      );
      await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${image_name?image_name:""} image from ${panel?panel:""} panel.`)

    await reference.delete();
    dispatcher(showSnackbarAction('Carousel Updated', 'success'));
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};

export const deleteLogoImage = async (
  organization_id: string,
  image_name: string,
  logoList: any[],
  index: number,
  dispatcher: any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${image_name?image_name:""} logo from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  const path = `logo/${organization_id}/${image_name}`;
  const reference = storage.ref(path);
  logoList.splice(index, 1);
  try {
    await firestore
      .collection('organizationResources')
      .doc(organization_id)
      .set(
        {
          logoList: logoList,
        },
        { merge: true }
      );
    await reference.delete();
    dispatcher(showSnackbarAction('Logo Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${image_name?image_name:""} logo from ${panel?panel:""} panel.`)
  } catch (e) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
  }
};

export const deleteLocation = async (
  location: string,
  organization_id: string,
  locationList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  let data: any[] = [];
  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('location', '==', location)
    .get()
    .then((contact) => {
      if (contact) {
        contact.forEach((item) => {
          data.push(item.data());
        });
      }

      if (data.length !== 0) {
        dispatcher(
          showSnackbarAction('This Location Is Used In Some Contacts', 'error')
        );
        setLoad(false);
      } else {
        locationList.splice(index, 1);
        try {
          firestore
            .collection('organizationResources')
            .doc(organization_id)
            .set(
              {
                locations: locationList,
              },
              { merge: true }
            );
          dispatcher(showSnackbarAction('Location Deleted', 'success'));
          setLoad(false);
        } catch (e) {
          console.log('Error:', e);
          dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
          setLoad(false);
        }
      }
    });
};

export const deleteComType = async (
  commercial: string,
  organization_id: string,
  commList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  let data: any[] = [];
  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('property_sub_type', '==', commercial)
    .get()
    .then((contact) => {
      if (contact) {
        contact.forEach((item) => {
          data.push(item.data());
        });
      }

      if (data.length !== 0) {
        dispatcher(
          showSnackbarAction(
            'This Commercial Type Is Used In Some Contacts',
            'error'
          )
        );
        setLoad(false);
      } else {
        commList.splice(index, 1);
        try {
          firestore
            .collection('organizationResources')
            .doc(organization_id)
            .set(
              {
                comTypes: commList,
              },
              { merge: true }
            );
          dispatcher(showSnackbarAction('Commercial Type Deleted', 'success'));
          setLoad(false);
        } catch (e) {
          console.log('Error:', e);
          dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
          setLoad(false);
        }
      }
    });
};

export const deleteResidential = async (
  residential: string,
  organization_id: string,
  resList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  let data: any[] = [];
  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('property_sub_type', '==', residential)
    .get()
    .then((contact) => {
      if (contact) {
        contact.forEach((item) => {
          data.push(item.data());
        });
      }

      if (data.length !== 0) {
        dispatcher(
          showSnackbarAction(
            'This Residential Type Is Used In Some Contacts',
            'error'
          )
        );
        setLoad(false);
      } else {
        resList.splice(index, 1);
        try {
          firestore
            .collection('organizationResources')
            .doc(organization_id)
            .set(
              {
                resTypes: resList,
              },
              { merge: true }
            );
          dispatcher(showSnackbarAction('Residential Type Deleted', 'success'));
          setLoad(false);
        } catch (e) {
          console.log('Error:', e);
          dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
          setLoad(false);
        }
      }
    });
};

export const deleteBudget = (
  budget: string,
  organization_id: string,
  budgetList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  let data: any[] = [];
  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('budget', '==', budget)
    .get()
    .then((contact) => {
      if (contact) {
        contact.forEach((item) => {
          data.push(item.data());
        });
      }

      if (data.length !== 0) {
        dispatcher(
          showSnackbarAction('This Budget Is Used In Some Contacts', 'error')
        );
        setLoad(false);
      } else {
        budgetList.splice(index, 1);
        try {
          firestore
            .collection('organizationResources')
            .doc(organization_id)
            .set(
              {
                budgets: budgetList,
              },
              { merge: true }
            );
          dispatcher(showSnackbarAction('Budget Deleted', 'success'));
          setLoad(false);
        } catch (e) {
          console.log('Error:', e);
          dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
          setLoad(false);
        }
      }
    });
};

export const deleteLeadSource = (
  leadSource: string,
  organization_id: string,
  leadSourceList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  let data: any[] = [];
  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('lead_source', '==', leadSource)
    .get()
    .then((contact) => {
      if (contact) {
        contact.forEach((item) => {
          data.push(item.data());
        });
      }

      if (data.length !== 0) {
        dispatcher(
          showSnackbarAction(
            'This Lead Source Is Used In Some Contacts',
            'error'
          )
        );
        setLoad(false);
      } else {
        leadSourceList.splice(index, 1);
        try {
          firestore
            .collection('organizationResources')
            .doc(organization_id)
            .set(
              {
                leadSources: leadSourceList,
              },
              { merge: true }
            );
          dispatcher(showSnackbarAction('Lead Source Deleted', 'success'));
          setLoad(false);
        } catch (e) {
          console.log('Error:', e);
          dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
          setLoad(false);
        }
      }
    });
};

export const editLocation = (
  organization_id: string,
  oldLocation: string,
  newLocation: string,
  locationList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  locationList.forEach((location: any) => {
    if (location.location_name === oldLocation) {
      location.location_name = newLocation;
    }
  });

  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('location', '==', oldLocation)
    .get()
    .then((contact) => {
      const batch = firestore.batch();
      if (contact.docs.length <= 500) {
        contact.docs.forEach((item) => {
          const contactsRef = firestore.collection('contacts').doc(item.id);
          batch.set(contactsRef, { location: newLocation }, { merge: true });
        });

        const resRef = firestore
          .collection('organizationResources')
          .doc(organization_id);
        batch.set(
          resRef,
          {
            locations: locationList,
          },
          { merge: true }
        );
        batch.commit().then(() => {
          dispatcher(showSnackbarAction('Location Updated', 'success'));
          setLoad(false);
        });
      }
    });
};

export const editProjectDetails = (
  organization_id: string,
  projectsList: any[],
  oldProjectName: string,
  project_name: string,
  developer_name: string,
  address: string,
  property_type: string,
  project_status:string,
  property_stage:string,
  rera_link: string,
  walkthrough_link: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  business_vertical:any,
) => {
  projectsList.forEach((project) => {
    if (project.project_name === oldProjectName) {
      project.project_name = project_name;
      project.developer_name = developer_name;
      project.address = address;
      project.property_type = property_type;
      project.project_status = project_status;
      project.rera_link = rera_link;
      project.walkthrough_link = walkthrough_link;
      project.property_stage = property_stage;
      project.business_vertical = business_vertical;
    }
  });
  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('project', '==', oldProjectName)
    .get()
    .then((contact) => {
      const batch = firestore.batch();
      if (contact.docs.length <= 500) {
        contact.docs.forEach((item) => {
          const contactsRef = firestore.collection('contacts').doc(item.id);
          batch.set(contactsRef, { project: project_name }, { merge: true });
        });
      } else {
        contact.docs.forEach((contacts) => {
          firestore.collection('contacts').doc(contacts.id).set(
            {
              project: project_name,
            },
            { merge: true }
          );
        });
      }
      const resRef = firestore
        .collection('organizationResources')
        .doc(organization_id);
      batch.set(
        resRef,
        {
          projects: projectsList,
        },
        { merge: true }
      );
      batch
        .commit()
        .then(() => {
          dispatcher(showSnackbarAction('Project Updated', 'success'));
          setLoad(false);
        })
        .catch((error) => {
          console.log('edit project error:', error);
        });
    });
};

export const editBudget = (
  organization_id: string,
  oldBudget: string,
  newBudget: string,
  budgetList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  budgetList.forEach((budget: any) => {
    if (budget.budget === oldBudget) {
      budget.budget = newBudget;
    }
  });

  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('budget', '==', oldBudget)
    .get()
    .then((contact) => {
      const batch = firestore.batch();
      if (contact.docs.length <= 500) {
        contact.docs.forEach((item) => {
          const contactsRef = firestore.collection('contacts').doc(item.id);
          batch.set(contactsRef, { budget: newBudget }, { merge: true });
        });

        const resRef = firestore
          .collection('organizationResources')
          .doc(organization_id);
        batch.set(
          resRef,
          {
            budgets: budgetList,
          },
          { merge: true }
        );
        batch.commit().then(() => {
          dispatcher(showSnackbarAction('Budget Updated', 'success'));
          setLoad(false);
        });
      }
    });
};

export const editLeadSource = (
  organization_id: string,
  oldLeadSource: string,
  newLeadSource: string,
  leadSourceList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  leadSourceList.forEach((leadSource: any) => {
    if (leadSource.leadSource === oldLeadSource) {
      leadSource.leadSource = newLeadSource;
    }
  });

  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('lead_source', '==', oldLeadSource)
    .get()
    .then((contact) => {
      const batch = firestore.batch();
      if (contact.docs.length <= 500) {
        contact.docs.forEach((item) => {
          const contactsRef = firestore.collection('contacts').doc(item.id);
          batch.set(
            contactsRef,
            { lead_source: newLeadSource },
            { merge: true }
          );
        });

        const resRef = firestore
          .collection('organizationResources')
          .doc(organization_id);
        batch.set(
          resRef,
          {
            leadSources: leadSourceList,
          },
          { merge: true }
        );
        batch.commit().then(() => {
          dispatcher(showSnackbarAction('Lead Source Updated', 'success'));
          setLoad(false);
        });
      }
    });
};

export const editCommType = (
  organization_id: string,
  oldValue: string,
  newValue: string,
  commList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  commList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      commList[index] = newValue;
    }
  });

  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('property_sub_type', '==', oldValue)
    .get()
    .then((contact) => {
      const batch = firestore.batch();
      if (contact.docs.length <= 500) {
        contact.docs.forEach((item) => {
          const contactsRef = firestore.collection('contacts').doc(item.id);
          batch.set(
            contactsRef,
            { property_sub_type: newValue },
            { merge: true }
          );
        });

        const resRef = firestore
          .collection('organizationResources')
          .doc(organization_id);
        batch.set(
          resRef,
          {
            comTypes: commList,
          },
          { merge: true }
        );
        batch.commit().then(() => {
          dispatcher(
            showSnackbarAction('Commercial Property Type Updated', 'success')
          );
          setLoad(false);
        });
      }
    });
};

export const editResType = (
  organization_id: string,
  oldValue: string,
  newValue: string,
  resList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  resList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      resList[index] = newValue;
    }
  });

  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('property_sub_type', '==', oldValue)
    .get()
    .then((contact) => {
      const batch = firestore.batch();
      if (contact.docs.length <= 500) {
        contact.docs.forEach((item) => {
          const contactsRef = firestore.collection('contacts').doc(item.id);
          batch.set(
            contactsRef,
            { property_sub_type: newValue },
            { merge: true }
          );
        });

        const resRef = firestore
          .collection('organizationResources')
          .doc(organization_id);
        batch.set(
          resRef,
          {
            resTypes: resList,
          },
          { merge: true }
        );
        batch.commit().then(() => {
          dispatcher(
            showSnackbarAction('Residential Property Type Updated', 'success')
          );
          setLoad(false);
        });
      }
    });
};

export const uploadProjectResources = async (
  file: any,
  projectData: any,
  type: string,
  fileName: string,
  dispatcher: any
) => {
  const path = `project/${projectData.project_id}/${type}/${fileName}`;
  const reference = storage.ref(path);

  try {
    await reference.put(file);
    const url = await reference.getDownloadURL();
    let fileNameSplit = fileName.split('.');
    let fileType = '';

    if (fileNameSplit[fileNameSplit.length - 1] === 'pdf') {
      fileType = 'pdf';
    } else {
      fileType = 'image';
    }

    try {
      await firestore
        .collection('projectResources')
        .doc(projectData.project_id)
        .set(
          {
            [type]: Firebase.firestore.FieldValue.arrayUnion({
              link: url,
              created_at: Firebase.firestore.Timestamp.now(),
              name: fileName,
              type: fileType,
            }),
          },
          { merge: true }
        );
      dispatcher(showSnackbarAction('Document Added!!', 'success'));
    } catch (error) {
      console.log('project upload Error', error);
      dispatcher(showSnackbarAction('Error!! Try Again!!', 'error'));
    }
  } catch (error) {
    console.log('project upload Error', error);
    dispatcher(showSnackbarAction('Error!! Try Again!!', 'error'));
  }
};
export const uploadProjectTemplate = async (
  projectData: any,
  type: string,
  dispatcher: any,
  project_template: any,
  user:any,
  authToken:any
) => {
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken
      let res = await axiosHandler.post(url + '/projectResources/update', {
        organization_id: user.organization_id,
        project_id:projectData.project_id,
        project_name:projectData.project_name,
        project_description:project_template,
        userAuthorizationId:user.uid
      })
    dispatcher(showSnackbarAction('Project Template Added!!', 'success'));
    window.location.reload()
  } catch (error:any) {
    dispatcher(showSnackbarAction( error.response.data.message || 'Error!! Try Again!!', 'error'));
  }
};


export const deleteProjectTemplate = async (
  type: string,
  template: any,
  project_id: any,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted template ${template} from ${project_name} project from ${panel?panel:""} panel.`
//       })
//     } catch (error) { }
// }
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken
      let res = await axiosHandler.post(url + '/projectResources/delete', {
        project_id: project_id,
        project_description:template,
        userAuthorizationId:user.uid
      })
    dispatcher(showSnackbarAction('Template Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted template ${template} from ${project_name} project from ${panel?panel:""} panel.`)
    window.location.reload()
  } catch (e:any) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction(e.response.data.message || 'Error! Try Again.', 'error'));
  }
};
export const fetchProjectDocuments = (
  project_id: string,
  setBrochures: (data: any[]) => void,
  setPriceLists: (data: any[]) => void,
  setLayouts: (data: any[]) => void,
  setForms: (data: any[]) => void,
  setAttachmentsList: (data: any[]) => void,
  setImages: (data: any[]) => void
) => {
  firestore
    .collection('projectResources')
    .doc(project_id)
    .onSnapshot((resources) => {
      if (resources) {
        const resourcesData = resources.data();
        console.log("amkalo",project_id,resourcesData);
        if (resourcesData?.brochures) {
          setBrochures(resourcesData.brochures);
        } else {
          setBrochures([]);
        }
        if (resourcesData?.priceLists) {
          setPriceLists(resourcesData.priceLists);
        } else {
          setPriceLists([]);
        }
        if (resourcesData?.video) {
          setAttachmentsList(resourcesData.video);
        } else {
          setAttachmentsList([]);
        }
        if (resourcesData?.layouts) {
          setLayouts(resourcesData.layouts);
        } else {
          setLayouts([]);
        }
        if (resourcesData?.forms) {
          setForms(resourcesData.forms);
        } else {
          setForms([]);
        }
        if (resourcesData?.images) {
          setImages(resourcesData.images);
        } else {
          setImages([]);
        }
      } else {
        console.log('document not found');
      }
    });
};

export const setProjectImage = async (
  organization_id: string,
  file: any,
  projectList: any,
  projectData: any,
  deletePrev: boolean,
  dispatcher: any
) => {
  const path = `project/${projectData.project_id}/thumbnail`;
  const reference = storage.ref(path);
  if (deletePrev) {
    await reference.delete();
  }
  try {
    await reference.put(file);
    const url = await reference.getDownloadURL();
    try {
      let projects = [...projectList];
      projects.forEach((project: any, index: number) => {
        if (project.project_id === projectData.project_id) {
          let newProject = { ...project, project_image: url };
          projects[index] = newProject;
        }
      });
      await firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set({ projects }, { merge: true });
    } catch (error) {
      console.log('Project Image Upload Error', error);
      dispatcher(showSnackbarAction('Error!!', 'error'));
    }
  } catch (error) {
    console.log('Project Image Upload Error', error);
    dispatcher(showSnackbarAction('Error!!', 'error'));
  }
};

export const createFAQ = (
  organization_id: string,
  question: string,
  answer: string,
  serialNumber: string,
  dispatcher: any,

  setLoad: (data: boolean) => void,
  history: any
) => {
  let numberType = Math.floor((Math.random() * 100000) + 1);
  let q = question.substring(0, 2)
  let a = answer.substring(0, 2)
  let id = `${q}${numberType}${a}`
  firestore
    .collection('faq')
    .doc(organization_id)
    .set(
      {
        FAQ: Firebase.firestore.FieldValue.arrayUnion({
          question: question,
          answer: answer,
          serialNumber: serialNumber,
          id
        }),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('FAQ Added', 'success'));
      setLoad(false);
      history.push('/faq');
    })
    .catch((error) => {
      console.log('FAQ Error', error);
      dispatcher(showSnackbarAction('Error!! Please Try Again!!', 'error'));
      setLoad(false);
      history.push('/faq');
    });
};

export const updateFAQ = (
  organization_id: string,
  filterDataArr: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  history: any,
) => {
  firestore
    .collection('faq')
    .doc(organization_id).set(
      { FAQ: filterDataArr },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('FAQ Update', 'success'));
      setLoad(false);
      history.push('/faq');
    })
    .catch((error) => {
      console.log('FAQ Error', error);
      dispatcher(showSnackbarAction('Error!! Please Try Again!!', 'error'));
      setLoad(false);
      history.push('/faq');
    });
};
export const deleteFAQ =  (
  organization_id: string,
  filterDataArr: any,
  dispatcher: any,
  history: any,
  faqId?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken 
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted 
//       a Qusetion (${faqId.question?faqId.question:""})  from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  firestore
    .collection('faq')
    .doc(organization_id).set(
      { FAQ: filterDataArr },
      { merge: true }
    )
    .then(async () => {
      await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted a Qusetion (${faqId.question?faqId.question:""})  from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('FAQ Deleted', 'success'));
      history.push('/faq');
    })
    .catch((error) => {
      console.log('FAQ Error ', error);
      dispatcher(showSnackbarAction('Error!! Please Try Again!!', 'error'));
      history.push('/faq');
    });
};
export const fetchFAQ = (
  organization_id: string,
  setFAQ: (data: any[]) => void
) => {
  const subscriber = firestore
    .collection('faq')
    .doc(organization_id)
    .onSnapshot((faqs) => {
      if (faqs) {
        const faqData = faqs.data();
        if (faqData?.FAQ) {
          const filterData = faqData?.FAQ.sort((a: any, b: any) => a.serialNumber - b.serialNumber)
          setFAQ(filterData);
        }
        else {
          setFAQ([]);
        }
      } else {
        console.log('FAQ Org not found');
      }
    });
  return subscriber;
};

const sortResources = (a: any, b: any) => {
  if (a.created_at.toDate() > b.created_at.toDate()) {
    return -1;
  } else {
    return 1;
  }
};
export const mapCallLogs = (
  data: { [key: string]: any }[],
  map: { [key: string]: string },
  organization_id: string,
  dispatcher: any,
  submit: () => void,
  usersList: any[],
  setLoad: (data: boolean) => void
) => {
  let templateList: any[] = [];
  data.forEach((call, index) => {
    let uid = '';
    if (map['Owner']) {
      const userData = usersList.filter(
        (item) =>
          String(item.user_email).toLowerCase() ===
          String(call[map['Owner']].toLowerCase())
      );
      uid = userData.length === 0 ? '' : userData[0].uid;
      if (uid === '') {
        dispatcher(
          showSnackbarAction(
            'Please Provide The Owner For the Contact At: ' + index + 1,
            'error'
          )
        );
        return;
      }
    }
    if (!map.hasOwnProperty('Duration')) {
      dispatcher(showSnackbarAction('Please Select Call Duration', 'error'));
      templateList = [];
      setLoad(false);
      return;
    } else if (!map.hasOwnProperty('Contact ID')) {
      dispatcher(showSnackbarAction('Please Select Contact ID', 'error'));
      templateList = [];
      setLoad(false);
      return;
    } else if (call[map['Duration']] === '') {
      dispatcher(
        showSnackbarAction('Invalid Duration at row ' + call.sno, 'error')
      );
      templateList = [];
      setLoad(false);
      return;
    } else if (call[map['Contact ID']] === '') {
      dispatcher(
        showSnackbarAction('Invalid Contact ID at row ' + call.sno, 'error')
      );
      templateList = [];
      setLoad(false);
      return;
    }
    templateList.push({
      callTime: map['Duration'] ? call[map['Duration']] : '',
      created_at: map['Created At']
        ? call[map['Created At']] !== ''
          ? Firebase.firestore.Timestamp.fromDate(
            moment(call[map['Created At']], 'MM/DD/YY HH:mm').toDate()
          )
          : Firebase.firestore.Timestamp.now()
        : Firebase.firestore.Timestamp.now(),
      contactId: map['Contact ID'] ? call[map['Contact ID']] : '',
      uid: uid,
    });
  });

  if (templateList.length === data.length) {
    createCallLogs(
      templateList,
      dispatcher,
      submit,
      (data: boolean) => setLoad(data),
      organization_id
    );
  } else {
    setLoad(false);
  }
};

const createCallLogs = async (
  data: any[],
  dispatcher: any,
  submit: () => void,
  setLoad: (data: boolean) => void,
  organization_id: any
) => {
  let callLogs: { [key: string]: [{}] } = {};
  let uidMap: { [key: string]: string } = {};
  data.forEach((item) => {
    if (callLogs[item.contactId]) {
      callLogs[item.contactId].push({
        callTime: item.callTime,
        created_at: item.created_at,
      });
    } else {
      callLogs[item.contactId] = [
        { callTime: item.callTime, created_at: item.created_at },
      ];
    }
    if (uidMap[item.contactId]) {
      uidMap[item.contactId] = item.uid;
    } else {
      uidMap[item.contactId] = item.uid;
    }
  });
  const callLogsData: any[] = [];
  Object.keys(callLogs).forEach((key) => {
    callLogsData.push({ id: key, data: callLogs[key], uid: uidMap[key] });
  });
  if (callLogsData.length > 500) {
    dispatcher(setTotal(callLogsData.length));
    const splitedData = chunk(callLogsData, 500);
    dispatcher(setCompleted(0));
    let total = 0;
    try {
      for (let i = 0; i < splitedData.length; i++) {
        total += splitedData[i].length;
        await createMultipleCallLogs(splitedData[i], organization_id);
        dispatcher(setCompleted(total));
      }
      dispatcher(setTotal(0));

      dispatcher(showSnackbarAction('Call Logs Uploaded!!', 'success'));
      submit();
      setLoad(false);
    } catch (error) {
      console.log('Call Logs upload error!!', error);
      setLoad(false);
      dispatcher(showSnackbarAction('Try Again!!', 'error'));
    }
  } else {
    createMultipleCallLogs(callLogsData, organization_id)
      .then(() => {
        dispatcher(showSnackbarAction('Call Logs Uploaded', 'success'));
        setLoad(false);
        submit();
      })
      .catch((error) => {
        console.log('Call logs upload error!!', error);
        setLoad(false);
      });
  }
};

const createMultipleCallLogs = async (data: any[], organization_id: string) => {
  const batch = firestore.batch();

  data.forEach((key) => {
    const callRef = firestore.collection('contactResources').doc(key.id);
    batch.set(
      callRef,
      {
        callLogs: key.data.sort(sortResources),
        organization_id: organization_id,
        uid: key.uid,
      },
      { merge: true }
    );
  });

  batch.commit();
};

export const mapNotes = (
  data: { [key: string]: any }[],
  map: { [key: string]: string },
  dispatcher: any,
  submit: () => void,
  setLoad: (data: boolean) => void
) => {
  let templateList: any[] = [];

  data.forEach((note, index) => {
    if (!map.hasOwnProperty('Note')) {
      dispatcher(showSnackbarAction('Please Select Note', 'error'));
      templateList = [];
      setLoad(false);
      return;
    } else if (!map.hasOwnProperty('Contact ID')) {
      dispatcher(showSnackbarAction('Please Select Contact ID', 'error'));
      templateList = [];
      setLoad(false);
      return;
    } else if (note[map['Note']] === '') {
      dispatcher(
        showSnackbarAction('Invalid Note at row ' + note.sno, 'error')
      );
      templateList = [];
      setLoad(false);
      return;
    } else if (note[map['Contact ID']] === '') {
      dispatcher(
        showSnackbarAction('Invalid Contact ID at row ' + note.sno, 'error')
      );
      templateList = [];
      setLoad(false);
      return;
    }
    templateList.push({
      note: map['Note'] ? note[map['Note']] : '',
      created_at: map['Created At']
        ? note[map['Created At']] !== ''
          ? Firebase.firestore.Timestamp.fromDate(
            moment(note[map['Created At']], 'MM/DD/YY HH:mm').toDate()
          )
          : Firebase.firestore.Timestamp.now()
        : Firebase.firestore.Timestamp.now(),
      contactId: map['Contact ID'] ? note[map['Contact ID']] : '',
    });
  });

  if (templateList.length === data.length) {
    createNotes(templateList, dispatcher, submit, (data: boolean) =>
      setLoad(data)
    );
  } else {
    setLoad(false);
  }
};

const createNotes = async (
  data: any[],
  dispatcher: any,
  submit: () => void,
  setLoad: (data: boolean) => void
) => {
  let notes: { [key: string]: [{}] } = {};

  data.forEach((item) => {
    if (notes[item.contactId]) {
      notes[item.contactId].push({
        note: item.note,
        created_at: item.created_at,
      });
    } else {
      notes[item.contactId] = [
        { note: item.note, created_at: item.created_at },
      ];
    }
  });
  const notesData: any[] = [];
  Object.keys(notes).forEach((key) => {
    notesData.push({ id: key, data: notes[key] });
  });
  if (notesData.length > 500) {
    dispatcher(setTotal(notesData.length));
    const splitedData = chunk(notesData, 500);
    dispatcher(setCompleted(0));
    let total = 0;
    try {
      for (let i = 0; i < splitedData.length; i++) {
        total += splitedData[i].length;
        await createMultipleNotes(splitedData[i]);
        dispatcher(setCompleted(total));
      }
      dispatcher(setTotal(0));
      dispatcher(showSnackbarAction('Notes Uploaded!!', 'success'));
      submit();
      setLoad(false);
    } catch (error) {
      console.log('Notes upload error!!', error);
      setLoad(false);
      dispatcher(showSnackbarAction('Try Again!!', 'error'));
    }
  } else {
    createMultipleNotes(notesData)
      .then(() => {
        dispatcher(showSnackbarAction('Notes Uploaded', 'success'));
        setLoad(false);
        submit();
      })
      .catch((error) => {
        console.log('Notes upload error!!', error);
        setLoad(false);
      });
  }
};

const createMultipleNotes = async (data: any[]) => {
  const batch = firestore.batch();

  data.forEach((item) => {
    const noteRef = firestore.collection('contactResources').doc(item.id);
    batch.set(
      noteRef,
      {
        notes: item.data.sort(sortResources),
      },
      { merge: true }
    );
  });
  batch.commit();
};

export const mapTasks = (
  data: { [key: string]: any }[],
  map: { [key: string]: string },
  dispatcher: any,
  submit: () => void,
  setLoad: (data: boolean) => void,
  organization_id: string,
  usersList: any[],
  name: string
) => {
  let templateList: any[] = [];
  let checkStatus = true;
  data.forEach((task: any, index: number) => {
    if (checkStatus === false) {
      setLoad(false);
      return;
    }
    let uid = '';
    if (!map.hasOwnProperty('Owner')) {
      dispatcher(showSnackbarAction('Please Select Owner', 'error'));

      checkStatus = false;
      return;
    }
    if (map['Owner']) {
      const userData = usersList.filter(
        (item) =>
          String(item.user_email).toLowerCase() ===
          String(task[map['Owner']].toLowerCase())
      );
      uid = userData.length === 0 ? '' : userData[0].uid;
      if (uid === '') {
        dispatcher(
          showSnackbarAction(
            'Please Provide The Owner For the Contact At: ' + index + 1,
            'error'
          )
        );
        checkStatus = false;
        return;
      }
    }

    if (!map.hasOwnProperty('Status')) {
      dispatcher(showSnackbarAction('Please Select Status', 'error'));
      checkStatus = false;
      return;
    } else if (
      task[map['Status']] === '' ||
      (properFormat(task[map['Status']]).trim() !== 'Overdue' &&
        properFormat(task[map['Status']]).trim() !== 'Pending' &&
        properFormat(task[map['Status']]).trim() !== 'Completed')
    ) {
      dispatcher(
        showSnackbarAction('Invalid Status at row ' + task.sno, 'error')
      );
      checkStatus = false;
      return;
    }

    if (properFormat(task[map['Status']]).trim() === 'Overdue') {
      checkStatus = OverdueTaskValidation(map, dispatcher, task);
    } else if (properFormat(task[map['Status']]).trim() === 'Completed') {
      checkStatus = CompletedTaskValidation(map, dispatcher, task);
    } else if (properFormat(task[map['Status']]).trim() === 'Pending') {
      checkStatus = PendingTaskValidation(map, dispatcher, task);
    }
    if (checkStatus === false) {
      return;
    }
    if (properFormat(task[map['Task Type']]) === 'Call Back') {
      if (task[map['Call Back Reason']] === '') {
        dispatcher(
          showSnackbarAction(
            'Invalid Call Back Reason at row: ' + task.sno,
            'error'
          )
        );
        checkStatus = false;
        return;
      }
    }
    let taskObj = {
      call_back_reason: map['Call Back Reason']
        ? task[map['Call Back Reason']]
        : '',
      created_at: map['Created At']
        ? task[map['Created At']] !== ''
          ? Firebase.firestore.Timestamp.fromDate(
            moment(task[map['Created At']], 'MM/DD/YY HH:mm').toDate()
          )
          : Firebase.firestore.Timestamp.now()
        : Firebase.firestore.Timestamp.now(),
      created_by: map['Created By'] ? task[map['Created By']] : name,
      customer_name: map['Customer Name'] ? task[map['Customer Name']] : '',
      due_date: map['Due Date']
        ? task[map['Due Date']] !== ''
          ? Firebase.firestore.Timestamp.fromDate(
            moment(task[map['Due Date']], 'MM/DD/YY HH:mm').toDate()
          )
          : ''
        : '',
      leadId: map['Lead Id'] ? task[map['Lead Id']] : '',
      status: map['Status']
        ? task[map['Status']] === 'Overdue' || task[map['Status']] === 'overdue'
          ? 'Pending'
          : properFormat(task[map['Status']])
        : '',
      type: map['Task Type'] ? properFormat(task[map['Task Type']]) : '',
      uid: uid,
    };
    if (task[map['Status']] === 'Completed') {
      let newTaskObj = {
        ...taskObj,
        completed_at: map['Completed Date']
          ? task[map['Completed Date']] !== ''
            ? Firebase.firestore.Timestamp.fromDate(
              moment(task[map['Completed Date']], 'MM/DD/YY HH:mm').toDate()
            )
            : ''
          : '',
      };
      templateList.push(newTaskObj);
    } else {
      templateList.push(taskObj);
    }
  });

  if (templateList.length === data.length) {
    createMultipleTasks(
      templateList,
      dispatcher,
      submit,
      (data: boolean) => setLoad(data),
      organization_id
    );
  } else {
    setLoad(false);
  }
};

export const createMultipleTasks = async (
  data: any[],
  dispatcher: any,
  submit: () => void,
  setLoad: (data: boolean) => void,
  organization_id: any
) => {
  let tasks: { [key: string]: [any] } = {};
  let uidMap: { [key: string]: string } = {};
  let check = true;
  data.forEach((item) => {
    if (check === false) {
      setLoad(false);
      submit();
      tasks = {};
      return;
    }

    let taskObj = {
      call_back_reason: item.call_back_reason,
      created_at: Firebase.firestore.Timestamp.now(),
      created_by: item.created_by,
      customer_name: item.customer_name,
      due_date: item.due_date,
      leadId: item.leadId,
      status: item.status,
      type: item.type,
    };

    if (tasks[item.leadId]) {
      if (item.status === 'Completed') {
        tasks[item.leadId].push({
          ...taskObj,
          completed_at: item.completed_at,
        });
      } else {
        tasks[item.leadId].push(taskObj);
      }
    } else {
      if (item.status === 'Completed') {
        let newTaskObj = { ...taskObj, completed_at: item.completed_at };
        tasks[item.leadId] = [newTaskObj];
      } else {
        tasks[item.leadId] = [taskObj];
      }
    }
    if (uidMap[item.leadId]) {
      uidMap[item.leadId] = item.uid;
    } else {
      uidMap[item.leadId] = item.uid;
    }
  });

  Object.keys(tasks).forEach((key) => {
    let pendingCount = 0;
    let pendingTask = {};
    tasks[key].forEach((task: any, index) => {
      if (task.status === 'Pending') {
        pendingCount += 1;
        pendingTask = { ...task };
        tasks[key].splice(index, 1);
      }
    });
    if (pendingCount > 1) {
      dispatcher(showSnackbarAction('Invalid Tasks for User: ' + key, 'error'));
      check = false;
      return;
    } else {
      if (Object.keys(pendingTask).length !== 0) {
        tasks[key].unshift(pendingTask);
      }
    }
  });
  const tasksData: any[] = [];
  Object.keys(tasks).forEach((key) => {
    tasksData.push({ id: key, data: tasks[key], uid: uidMap[key] });
  });
  if (tasksData.length > 500) {
    dispatcher(setTotal(tasksData.length));
    const splitedData = chunk(tasksData, 500);
    dispatcher(setCompleted(0));
    let total = 0;
    try {
      let check;
      for (let i = 0; i < splitedData.length; i++) {
        total += splitedData[i].length;
        check = await createTasks(
          splitedData[i],

          organization_id
        );
        dispatcher(setCompleted(total));
      }
      dispatcher(setTotal(0));
      if (check === true) {
        dispatcher(showSnackbarAction('Tasks Uploaded!!', 'success'));
        submit();
        setLoad(false);
      } else {
        submit();
        setLoad(false);
      }
    } catch (error) {
      console.log('Tasks upload error!!', error);
      setLoad(false);
      dispatcher(showSnackbarAction('Try Again!!', 'error'));
    }
  } else {
    let check = await createTasks(
      tasksData,

      organization_id
    );
    if (check === false) {
      dispatcher(showSnackbarAction('Error!!', 'error'));
      setLoad(false);
    } else {
      dispatcher(showSnackbarAction('Tasks Uploaded!!', 'success'));
      setLoad(false);
    }
  }
};

const createTasks = async (
  data: any[],

  organization_id: any
) => {
  const batch = firestore.batch();

  data.forEach((key) => {
    let status = key.data[0].status === 'Pending' ? 'ACTIVE' : 'INACTIVE';

    const taskRef = firestore.collection('tasks').doc(key.id);
    batch.set(
      taskRef,
      {
        tasks: key.data.sort(sortResources),
        organization_id: organization_id,
        uid: key.uid,
        status: status,
      },
      { merge: true }
    );
  });

  await batch.commit();
  return true;
};

export const createCommercialType = (
  organization_id: string,
  com_type: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        comTypes: Firebase.firestore.FieldValue.arrayUnion(com_type),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Commercial Type Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Commercial Type Error', error);
      setLoad(false);
    });
};

export const createResidentialType = (
  organization_id: string,
  res_type: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        resTypes: Firebase.firestore.FieldValue.arrayUnion(res_type),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Residential Type Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Residential Type Error', error);
      setLoad(false);
    });
};
export const createIndustrialType = (
  organization_id: string,
  industrial_type: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        industrialType: Firebase.firestore.FieldValue.arrayUnion(industrial_type),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Industrial Type Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Industrial Type Error', error);
      setLoad(false);
    });
};


export const createInstitutionalType = (
  organization_id: string,
  institutional_type: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        institutionalType: Firebase.firestore.FieldValue.arrayUnion(institutional_type),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Institutional Type Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Institutional Type Error', error);
      setLoad(false);
    });
};

export const createTransferReason = (
  organization_id: string,
  reason: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        TransferReasons: Firebase.firestore.FieldValue.arrayUnion(reason),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Transfer Reason Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Transfer Reason Error', error);
      setLoad(false);
    });
};

export const fetchTransferReason = (
  organization_id: string,
  setTransferReasons: (data: any[]) => void
) => {
  const subscriber = firestore
    .collection('organizationResources')
    .doc(organization_id)
    .onSnapshot((resources) => {
      if (resources) {
        const resourceData = resources.data();

        if (resourceData?.TransferReasons) {
          setTransferReasons &&
            setTransferReasons(resourceData?.TransferReasons.sort());
        } else {
          setTransferReasons && setTransferReasons([]);
        }
      } else {
        console.log('Org not found');
      }
    });
  return subscriber;
};

export const createBusinessVertical = (
  organization_id: string,
  businessVertical: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        businessVertical: Firebase.firestore.FieldValue.arrayUnion(businessVertical),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('Business Vertical Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('Business Vertical Error', error);
      setLoad(false);
    });
};

export const deleteBusinessVertical = (
  businessVertical: string,
  organization_id: string,
  businessVerticalList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  let data: any[] = [];
  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('business_vertical', '==', businessVertical)
    .get()
    .then((contact) => {
      if (contact) {
        contact.forEach((item) => {
          data.push(item.data());
        });
      }

      if (data.length !== 0) {
        dispatcher(
          showSnackbarAction(
            'This Business Vertical Is Used In Some Contacts',
            'error'
          )
        );
        setLoad(false);
      } else {
        businessVerticalList.splice(index, 1);
        try {
          firestore
            .collection('organizationResources')
            .doc(organization_id)
            .set(
              {
                businessVertical: businessVerticalList,
              },
              { merge: true }
            );
          dispatcher(showSnackbarAction('Business Vertical Deleted', 'success'));
          setLoad(false);
        } catch (e) {
          console.log('Error:', e);
          dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
          setLoad(false);
        }
      }
    });
};

export const editBusinessVertical = (
  organization_id: string,
  oldValue: string,
  newValue: string,
  businessVerticalList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void
) => {
  businessVerticalList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      businessVerticalList[index] = newValue;
    }
  });

  firestore
    .collection('contacts')
    .where('organization_id', '==', organization_id)
    .where('business_vertical', '==', oldValue)
    .get()
    .then((contact) => {
      const batch = firestore.batch();
      if (contact.docs.length > 0) {
        dispatcher(
          showSnackbarAction('This Business Vertical Is Used In Some Contacts', 'error')
        );
        setLoad(false);
      }else{
        const resRef = firestore
        .collection('organizationResources')
        .doc(organization_id);
        batch.set(
          resRef,
          {
            businessVertical: businessVerticalList,
          },
          { merge: true }
        );
        batch.commit().then(() => {
          dispatcher(
            showSnackbarAction('Business Vertical Updated', 'success')
          );
          setLoad(false);
        });
      }
    });
};

export const createAPIFormName = (
  organization_id: string,
  apiFormName: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        apiForms: Firebase.firestore.FieldValue.arrayUnion(apiFormName),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('API Form Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('API Form Error', error);
      setLoad(false);
    });
};

export const editAPIForms = (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldValue: string,
  newValue: string,
  formNamesList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  // formNamesList.forEach((item: any, index: number) => {
  //   if (item === oldValue) {
  //     formNamesList[index] = newValue;
  //   }
  // });
  // const batch = firestore.batch();
  // const resRef = firestore
  // .collection('organizationResources')
  // .doc(organization_id);
  // batch.set(
  //   resRef,
  //   {
  //     apiForms: formNamesList,
  //   },
  //   { merge: true }
  // );
  // batch.commit().then(() => {
  //   dispatcher(
  //     showSnackbarAction('API Forms Updated', 'success')
  //   );
  //   setLoad(false);
  // }); 
  editResourceMongo(editObj._id,organization_id,resource_type,[{apiForm:newValue,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
};

export const deleteAPIForm = async (
  apiFormName: string,
  organization_id: string,
  formNamesList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${apiFormName?apiFormName:""} API from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  let data: any[] = [];
  formNamesList.splice(index, 1);
        try {
          firestore
            .collection('organizationResources')
            .doc(organization_id)
            .set(
              {
                apiForms: formNamesList,
              },
              { merge: true }
            );
            await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${apiFormName?apiFormName:""} API from ${panel?panel:""} panel.`)
          dispatcher(showSnackbarAction('API Form Deleted', 'success'));
          setLoad(false);
        } catch (e) {
          console.log('Error:', e);
          dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
          setLoad(false);
        }
};

// Below this there is all code for migration purpose

export const deleteLocationMongo = async (
  location: string,
  organization_id: string,
  locationList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${location?location:""} location from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  let data: any[] = [];

  
  let apiData =  {
    organization_id: organization_id,
    location:location
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction('This Location Is Used In Some Contacts', 'error')
    );
    setLoad(false);
  } else {
    locationList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            locations: locationList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${location?location:""} location from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Location Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};

export const deleteBudgetMongo = async (
  budget: string,
  organization_id: string,
  budgetList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${budget?budget:""} budget from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  let data: any[] = [];

  let apiData =  {
    organization_id: organization_id,
    budget:budget
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction('This Budget Is Used In Some Contacts', 'error')
    );
    setLoad(false);
  } else {
    budgetList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            budgets: budgetList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${budget?budget:""} budget from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Budget Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }

};

export const deleteLeadSourceMongo = async (
  leadSource: string,
  organization_id: string,
  leadSourceList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${leadSource?leadSource:""} lead source from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  let data: any[] = [];

  let apiData =  {
    organization_id: organization_id,
    lead_source:leadSource
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Lead Source Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  } else {
    leadSourceList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            leadSources: leadSourceList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${leadSource?leadSource:""} lead source from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Lead Source Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};

export const deleteResidentialMongo = async (
  residential: string,
  organization_id: string,
  resList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted residential type ${residential?residential:""} from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  let data: any[] = [];
  
  let apiData =  {
    organization_id: organization_id,
    property_sub_type:residential
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Residential Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  } else {
    resList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            resTypes: resList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted residential type ${residential?residential:""} from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Residential Type Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};
export const deleteIndustrialMongo = async (
  industrial: string,
  organization_id: string,
  industrialList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
  let data: any[] = [];
  
  let apiData =  {
    organization_id: organization_id,
    property_sub_type:industrial
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Industrial Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  } else {
    industrialList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            industrialType: industrialList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted industrial type ${industrial?industrial:""} from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Industrial Type Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};


export const deleteInstitutionalMongo = async (
  institutional: string,
  organization_id: string,
  institutionalList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
  let data: any[] = [];
  
  let apiData =  {
    organization_id: organization_id,
    property_sub_type:institutional
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Institutional Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  } else {
    institutionalList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            institutionalType: institutionalList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted institutional type ${institutional?institutional:""} from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Institutional Type Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};

export const deleteComTypeMongo = async (
  commercial: string,
  organization_id: string,
  commList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted commercial type ${commercial?commercial:""} from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  let data: any[] = [];

  let apiData =  {
    organization_id: organization_id,
    property_sub_type:commercial
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Commercial Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  } else {
    commList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            comTypes: commList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted commercial type ${commercial?commercial:""} from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Commercial Type Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};

export const deleteBusinessVerticalMongo = async (
  businessVertical: string,
  organization_id: string,
  businessVerticalList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${businessVertical?businessVertical:""} image from ${panel?panel:""} panel.`
//       })
//       console.log("Delete Log Saved Successfully");
//     } catch (error) {
//       console.log(error,"Delete Log Couldn't Be Saved");
//     }
// }
  let data: any[] = [];

  let apiData =  {
    organization_id: organization_id,
    business_vertical:businessVertical
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Business Vertical Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  } else {
    businessVerticalList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            businessVertical: businessVerticalList,
          },
          { merge: true }
        );
        await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${businessVertical?businessVertical:""} image from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Business Vertical Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};

export const editBudgetMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldBudget: string,
  newBudget: string,
  budgetList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  budgetList.forEach((budget: any) => {
    if (budget.budget === oldBudget) {
      budget.budget = newBudget;
    }
  });

  
  let apiData =  {
    organization_id: organization_id,
    budget:oldBudget
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if(res.data.data.length !== 0){
    dispatcher(
      showSnackbarAction(
        'This Budget Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  }else{
    // const batch = firestore.batch();
    // const resRef = firestore
    // .collection('organizationResources')
    // .doc(organization_id);
    // batch.set(
    //   resRef,
    //   {
    //     budgets: budgetList,
    //   },
    //   { merge: true }
    // );
    // batch.commit().then(() => {
    //   dispatcher(showSnackbarAction('Budget Updated', 'success'));
    //   setLoad(false);
    // });
      

    editResourceMongo(editObj._id,organization_id,resource_type,[{budget:newBudget,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)

  }
};

export const editLeadSourceMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldLeadSource: string,
  newLeadSource: string,
  leadSourceList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  // leadSourceList.forEach((leadSource: any) => {
  //   if (leadSource.leadSource === oldLeadSource) {
  //     leadSource.leadSource = newLeadSource;
  //   }
  // });

  // let apiData =  {
  //   organization_id: organization_id,
  //   lead_source:oldLeadSource
  // }

  // axios.defaults.headers.common['x-access-token'] = authToken
  // let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  // const batch = firestore.batch();
  // if (res.data.data.length !== 0) {
  //   dispatcher(
  //     showSnackbarAction(
  //       'This Lead Source Is Used In Some Contacts',
  //       'error'
  //     )
  //   );
  //   setLoad(false);
  // }else{
    // const resRef = firestore
    // .collection('organizationResources')
    // .doc(organization_id);
    // batch.set(
    //   resRef,
    //   {
    //     leadSources: leadSourceList,
    //   },
    //   { merge: true }
    // );
    // batch.commit().then(() => {
    //   dispatcher(showSnackbarAction('Lead Source Updated', 'success'));
    //   setLoad(false);
    // });

    editResourceMongo(editObj._id,organization_id,resource_type,[{leadSource:newLeadSource,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  // }
};

export const editResTypeMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldValue: string,
  newValue: string,
  resList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  resList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      resList[index] = newValue;
    }
  });

  let apiData =  {
    organization_id: organization_id,
    property_sub_type:oldValue
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  const batch = firestore.batch();
  if (res.data.data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Property Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);
  }else{
    // const resRef = firestore
    // .collection('organizationResources')
    // .doc(organization_id);
    // batch.set(
    //   resRef,
    //   {
    //     resTypes: resList,
    //   },
    //   { merge: true }
    // );
    // batch.commit().then(() => {
    //   dispatcher(
    //     showSnackbarAction('Residential Property Type Updated', 'success')
    //   );
    //   setLoad(false);
    // });

    editResourceMongo(editObj._id,organization_id,resource_type,[{resType:newValue,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  }
};

export const editCommTypeMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldValue: string,
  newValue: string,
  commList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  commList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      commList[index] = newValue;
    }
  });

  let apiData =  {
    organization_id: organization_id,
    property_sub_type:oldValue
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);
  const batch = firestore.batch();
  if (res.data.data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Property Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);  
  }else{
    // const resRef = firestore
    //   .collection('organizationResources')
    //   .doc(organization_id);
    // batch.set(
    //   resRef,
    //   {
    //     comTypes: commList,
    //   },
    //   { merge: true }
    // );
    // batch.commit().then(() => {
    //   dispatcher(
    //     showSnackbarAction('Commercial Property Type Updated', 'success')
    //   );
    //   setLoad(false);
    // });
    editResourceMongo(editObj._id,organization_id,resource_type,[{comType:newValue,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  }
};
export const editIndustrialTypeMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldValue: string,
  newValue: string,
  industrialList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  industrialList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      industrialList[index] = newValue;
    }
  });

  let apiData =  {
    organization_id: organization_id,
    property_sub_type:oldValue
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);
  const batch = firestore.batch();
  if (res.data.data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Property Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);  
  }else{
    // const industrialRef = firestore
    //   .collection('organizationResources')
    //   .doc(organization_id);
    // batch.set(
    //   industrialRef,
    //   {
    //     industrialType: industrialList,
    //   },
    //   { merge: true }
    // );
    // batch.commit().then(() => {
    //   dispatcher(
    //     showSnackbarAction('Industrial Property Type Updated', 'success')
    //   );
    //   setLoad(false);
    // });
    editResourceMongo(editObj._id,organization_id,resource_type,[{industrialType:newValue,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  }
};
export const editInstitutionalTypeMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldValue: string,
  newValue: string,
  institutionalList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  institutionalList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      institutionalList[index] = newValue;
    }
  });

  let apiData =  {
    organization_id: organization_id,
    property_sub_type:oldValue
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);
  const batch = firestore.batch();
  if (res.data.data.length !== 0) {
    dispatcher(
      showSnackbarAction(
        'This Property Type Is Used In Some Contacts',
        'error'
      )
    );
    setLoad(false);  
  }else{
    // const institutionRef = firestore
    //   .collection('organizationResources')
    //   .doc(organization_id);
    // batch.set(
    //   institutionRef,
    //   {
    //     institutionalType: institutionalList,
    //   },
    //   { merge: true }
    // );
    // batch.commit().then(() => {
    //   dispatcher(
    //     showSnackbarAction('Institutional Property Type Updated', 'success')
    //   );
    //   setLoad(false);
    // });;
    editResourceMongo(editObj._id,organization_id,resource_type,[{institutionalType:newValue,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  }
};

export const editBusinessVerticalMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldValue: string,
  newValue: string,
  businessVerticalList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  businessVerticalList.forEach((item: any, index: number) => {
    if (item === oldValue) {
      businessVerticalList[index] = newValue;
    }
  });

  let apiData =  {
    organization_id: organization_id,
    business_vertical:oldValue
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  const batch = firestore.batch();
  if (res.data.data.length !== 0) {
    dispatcher(
      showSnackbarAction('This Business Vertical Is Used In Some Contacts', 'error')
    );
    setLoad(false);
  }else{
    // const resRef = firestore
    // .collection('organizationResources')
    // .doc(organization_id);
    // batch.set(
    //   resRef,
    //   {
    //     businessVertical: businessVerticalList,
    //   },
    //   { merge: true }
    // );
    // batch.commit().then(() => {
    //   dispatcher(
    //     showSnackbarAction('Business Vertical Updated', 'success')
    //   );
    //   setLoad(false);
    // });
    editResourceMongo(editObj._id,organization_id,resource_type,[{businessVertical:newValue,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  }
};

export const editLocationMongo = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldLocation: string,
  newLocation: string,
  locationList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  locationList.forEach((location: any) => {
    if (location.location_name === oldLocation) {
      location.location_name = newLocation;
    }
  });

  let apiData =  {
    organization_id: organization_id,
    location:oldLocation
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  const batch = firestore.batch();
  if (res.data.data.length !== 0) {
    dispatcher(
      showSnackbarAction('This Location Is Used In Some Contacts', 'error')
    );
    setLoad(false);
  }else{
  //   const resRef = firestore
  //   .collection('organizationResources')
  //   .doc(organization_id);
  // batch.set(
  //   resRef,
  //   {
  //     locations: locationList,
  //   },
  //   { merge: true }
  // );
  // batch.commit().then(() => {
  //   dispatcher(showSnackbarAction('Location Updated', 'success'));
  //   setLoad(false);
  // });
  editResourceMongo(editObj._id,organization_id,resource_type,[{location:newLocation,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  }
};

export const editProjectDetailsMongo = async (
  organization_id: string,
  projectsList: any[],
  oldProjectName: string,
  project_name: string,
  developer_name: string,
  address: string,
  property_type: string,
  project_status:string,
  property_stage:string,
  rera_link: string,
  walkthrough_link: string,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  business_vertical:any,
  authToken:any,
  history?: any,
) => {
  projectsList.forEach((project) => {
    if (project.project_name === oldProjectName) {
      project.project_name = project_name;
      project.developer_name = developer_name;
      project.address = address;
      project.property_type = property_type;
      project.project_status = project_status;
      project.rera_link = rera_link;
      project.walkthrough_link = walkthrough_link;
      project.property_stage = property_stage;
      project.business_vertical = business_vertical;
    }
  });

  // let apiData =  {
  //   organization_id: organization_id,
  //   project:oldProjectName
  // }

  // axios.defaults.headers.common['x-access-token'] = authToken
  // let res:any = await axios.post(url + '/leads/checkIfFieldExistsInLeads',apiData);
  
  const batch = firestore.batch();
  // if (res.data.data.length !== 0) {
  //   dispatcher(
  //     showSnackbarAction('This Project Is Used In Some Contacts', 'error')
  //   );
  //   setLoad(false);
  // } else {
    const resRef = firestore
    .collection('organizationResources')
    .doc(organization_id);
    batch.set(
      resRef,
      {
        projects: projectsList,
      },
      { merge: true }
    );
    batch
      .commit()
      .then(() => {
        dispatcher(showSnackbarAction('Project Updated', 'success'));
        setLoad(false);
        history.push("./projects");
      })
      .catch((error) => {
        console.log('edit project error:', error);
      });
  // }
};


export const deleteTemplateMongo = async (
  item: any,
  organization_id: string,
  templatesList: any[],
  index: number,
  dispatcher: any,
  setLoading: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
  setLoading(true);
  // const SaveData = async () => {
  //   try {
  //     let res = await axios.post(url+'/auditLogs/createExportLogs', {
  //     uid:user.uid?user.uid:"",
  //     user_email:user.user_email?user.user_email:"",
  //     user_first_name:user.user_first_name?user.user_first_name:"",
  //     user_last_name:user.user_last_name?user.user_last_name:"",
  //     total_count:selectedRows?.length?selectedRows?.length:"1",
  //     type:panel?panel:"",
  //     organization_id:user.organization_id?user.organization_id:"",
  //     operation_type:"Delete",
  //     description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted template from ${panel?panel:""} panel.`
  //     })
  //     console.log("Delete Log Saved Successfully");
  //   } catch (error) {
  //     console.log(error,"Delete Log Couldn't Be Saved");
  //     // setLoad(false);
  //     }
  //   }
    try {
      // axios.defaults.headers.common['x-access-token'] = authToken
      let res = await axiosHandler.post(url + '/organizationResources/delete',{
        organization_id:organization_id,
        custom_template:item
      });
      await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted template from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('Template Deleted', 'success'));
      setLoading(false);
      window.location.reload()
    } catch (e) {
      console.log('Error:', e);
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoading(false);
    }
  }
// };
export const uploadProjectMapURL = async (
  projectData: any,
  type: string,
  dispatcher: any,
  project_mapUrl: any,
  user:any,
  authToken:any
) => {
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken
      let res = await axiosHandler.post(url + '/projectResources/update', {
        organization_id: user.organization_id,
        project_id:projectData.project_id,
        project_name:projectData.project_name,
        project_map_url:project_mapUrl,
        userAuthorizationId:user.uid
      })
    dispatcher(showSnackbarAction('Map URL Added!!', 'success'));
    window.location.reload()
  } catch (err:any) {
    dispatcher(showSnackbarAction( err.response.data.message || 'Error!! Try Again!!', 'error'));
  }
};

export const deleteProjectMapURL = async (
  type: string,
  mapURL: any,
  project_id: any,
  dispatcher: any,
  project_name?:any,
  user?: any,
  panel?:any,
  authToken?:any,
  selectedRows?: any[],
) => {
//   const SaveData = async () => {
//     try {
//       axios.defaults.headers.common["x-access-token"] = authToken
//       let res = await axios.post(url+'/auditLogs/createExportLogs', {
//       uid:user.uid?user.uid:"",
//       user_email:user.user_email?user.user_email:"",
//       user_first_name:user.user_first_name?user.user_first_name:"",
//       user_last_name:user.user_last_name?user.user_last_name:"",
//       total_count:selectedRows?.length?selectedRows?.length:"1",
//       type:panel?panel:"",
//       organization_id:user.organization_id?user.organization_id:"",
//       operation_type:"Delete",
//       description:`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted template ${mapURL} from ${project_name} project from ${panel?panel:""} panel.`
//       })
//       window.location.reload()
//     } catch (error) { }
// }
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken
      let res = await axiosHandler.post(url + '/projectResources/delete', {
        project_id: project_id,
        project_map_url:mapURL,
        userAuthorizationId:user.uid
      })
    dispatcher(showSnackbarAction('URL Deleted', 'success'));
    await SaveData(authToken,user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted template ${mapURL} from ${project_name} project from ${panel?panel:""} panel.`)
    window.location.reload()
  } catch (e:any) {
    console.log('Error:', e);
    dispatcher(showSnackbarAction(e.response.data.message || 'Error! Try Again.', 'error'));
  }
};

export const editCustomTemplate = async (
  uid:string,
  organization_id: string,
  value: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void,
  custom_template:any,
  user_email:any,
  authToken:any,
  id:any
) => {
  try {setLoad(true);
    // axios.defaults.headers.common["x-access-token"] = authToken
    // let res = await axios.post(url+'/organizationResources/update', {
    //   organization_id:organization_id,
    //   custom_template : {
    //     Id:id,
    //     created_at:new Date(),
    //     template_name : value,
    //     template_data : custom_template,
    // //     created_by  :user_email,
    //   }      
    // })
    // dispatcher(showSnackbarAction('Template Added Successfully', 'success'));
    // setLoad(false);

    editResourceMongo(id,organization_id,"custom_templates",[{ template_name : value,
                                                               template_data : custom_template,
                                                               modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
    window.location.reload()
  } catch (error) {
    dispatcher(
      showSnackbarAction(
        "Template Error",
        'error'
      )
    );
    setLoad(false);
  } 
};


export const createState = (
  organization_id: string,
  state_name: string,
  dispatcher: any,
  history: any,
  setLoad: (data: boolean) => void
) => {
  firestore
    .collection('organizationResources')
    .doc(organization_id)
    .set(
      {
        state: Firebase.firestore.FieldValue.arrayUnion({
          state_name: state_name,
          created_at: Firebase.firestore.Timestamp.now(),
        }),
      },
      { merge: true }
    )
    .then(() => {
      dispatcher(showSnackbarAction('State Added', 'success'));
      setLoad(false);
      history.push('./resources');
    })
    .catch((error) => {
      console.log('State Error', error);
      setLoad(false);
    });
};

export const editState = async (
  uid:any,
  editObj:any,
  resource_type:string,
  organization_id: string,
  oldState: string,
  newState: string,
  stateList: any,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any
) => {
  stateList.forEach((state: any) => {
    if (state.state_name === oldState) {
      state.state_name = newState;
    }
  });

  let apiData =  {
    organization_id: organization_id,
    state:oldState
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  const batch = firestore.batch();
  if (res.data.data.length !== 0) {
    dispatcher(
      showSnackbarAction('This State Is Used In Some Contacts', 'error')
    );
    setLoad(false);
  }else{
  //   const resRef = firestore
  //   .collection('organizationResources')
  //   .doc(organization_id);
  // batch.set(
  //   resRef,
  //   {
  //     state: stateList,
  //   },
  //   { merge: true }
  // );
  // batch.commit().then(() => {
  //   dispatcher(showSnackbarAction('State Updated', 'success'));
  //   setLoad(false);
  // });

  editResourceMongo(editObj._id,organization_id,resource_type,[{state:newState,modified_by:uid}],dispatcher,setLoad,()=>{},authToken)
  }
};

export const deleteState = async (
  state: string,
  organization_id: string,
  stateList: any[],
  index: number,
  dispatcher: any,
  setLoad: (data: boolean) => void,
  authToken:any,
  user?: any,
  panel?:any,
  selectedRows?: any[],
) => {
  let data: any[] = [];

  
  let apiData =  {
    organization_id: organization_id,
    state:state
  }

  // axios.defaults.headers.common['x-access-token'] = authToken
  let res:any = await axiosHandler.post(url + '/leads/checkIfFieldExistsInLeads',apiData);

  if (res) {
    res.data.data.forEach((item:any) => {
      data.push(item);
    });
  }

  if (data.length !== 0) {
    dispatcher(
      showSnackbarAction('This State Is Used In Some Contacts', 'error')
    );
    setLoad(false);
  } else {
    stateList.splice(index, 1);
    try {
      firestore
        .collection('organizationResources')
        .doc(organization_id)
        .set(
          {
            state: stateList,
          },
          { merge: true }
        );
       await SaveData(user,selectedRows,panel,`${user.user_first_name?user.user_first_name:""} ${user.user_last_name?user.user_last_name:""} with user email ${user.user_email?user.user_email:""} deleted ${state?state:""} state from ${panel?panel:""} panel.`)
      dispatcher(showSnackbarAction('State Deleted', 'success'));
      setLoad(false);
    } catch (e) {
      dispatcher(showSnackbarAction('Error! Try Again.', 'error'));
      setLoad(false);
    }
  }
};

export const setConstants = async (
  authToken: any,
  dispatcher: any
) => {
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken;
    const res: any = await axiosHandler.get(url + "/constants/fetchConstant");
    if (res) {
      dispatcher(setconstants(res.data.data));
    }
  } catch (error) {
    console.log(error);
  }

}


export const updateUserPreference = async (
  authToken: any,
  dispatcher: any,
  userUid:any,
  organization_id:any
) => {
  try {
    // axios.defaults.headers.common["x-access-token"] = authToken;
    const res: any = await axiosHandler.get(url + "/userAuthorization/get", {
      params: { uid: userUid}
    });
    if (res) {
      dispatcher(setUserPreference(res.data.data));
    }
  } catch (error) {
    console.log('error',error);
  }
}


/////////////////// organization resource migration ////////////////////////////////////

export const fetchResourcesMongo = async (
  organizationResources:any,
  setLocations: (data: any[]) => void,
  setBudgets: (data: any[]) => void,
  setCarousel: (data: any[]) => void,
  setLeadSource: (data: any[]) => void,
  setComType: (data: any[]) => void,
  setResType: (data: any[]) => void,
  organizationId: string,
  authToken?: string,
  setTransferReasons?: (data: any[]) => void | undefined,
  setLogoList?: (data: any[]) => void | undefined,
  setBusinessVerticalList?: (data: any[]) => void | undefined,
  setFormNamesList?: (data: any[]) => void | undefined,
  setState?: (data: any[]) => void | undefined,
  setIndustrialTypes?: (data: any[]) => void | undefined,
  setInstitutionalTypes?: (data: any[]) => void | undefined,
  setTemplatesList?: (data: any[]) => void | undefined
): Promise<any> => {
  const ORG_RESOURCE = [
    { key: "custom_templates", setter: setTemplatesList },
    { key: "budgets", setter: setBudgets },
    { key: "carousel", setter: setCarousel },
    { key: "comTypes", setter: setComType },
    { key: "leadSources", setter: setLeadSource },
    { key: "locations", setter: setLocations },
    // { key: "permission", setter: undefined },
    { key: "industrialTypes", setter: setIndustrialTypes },
    { key: "institutionalTypes", setter: setInstitutionalTypes },
    { key: "states", setter: setState },
    { key: "resTypes", setter: setResType },
    { key: "apiForms", setter: setFormNamesList },
    { key: "transferReasons", setter: setTransferReasons },
    { key: "businessVertical", setter: setBusinessVerticalList }
  ];

  try {
    // Set the default header for axios
    // if (authToken) {
    //   axios.defaults.headers.common['x-access-token'] = authToken;
    // }

    // // Fetch resources
    // const response = await axios.get(`${url}/organizationResources/fetchAll`, {
    //   params: { organization_id: organizationId },
    // });

    organizationResources.forEach((val: any) => {
      ORG_RESOURCE.forEach(resource => {
        if (val.resource_type === resource.key && resource.setter) {
          const resourceData = val[resource.key] || [];  // Ensure default to empty array
          console.log(`Setting data for ${resource.key}:`, resourceData);
          resource.setter(resourceData);
        }
      });
    });

    // return response.data;
    return;
  } catch (error: any) {
    console.log('Error fetching resources:', error.message);
    // throw new Error(error.message);
  }
};


export const createResourceMongo = async (
  organizationId: string,
  resourceType:String,
  resourceObj:any,
  dispatcher:any,
  setLoad: (data: boolean) => void,
  close: () => void,
  authToken?: string,
  reload?:any
): Promise<any> => {
  try {

    const apiData:{ [key: string]: any }={
      organization_id:organizationId,
      resource_type:resourceType,
      [resourceType as string]:resourceObj ,
    }

    // console.log("apiData",apiData)
    // Set the default header for axios
    // if (authToken) {
    //   axios.defaults.headers.common['x-access-token'] = authToken;
    // }
    // Fetch resources
    const response = await axiosHandler.post(`${url}/organizationResources/createResource`,apiData);
    dispatcher(showSnackbarAction(response.data.message, 'success'));
    setLoad(false);
    close();

    {reload!==false &&
      setTimeout(() => {
      window.location.reload();
    }, 1000)
    fetchOrgResMongo(organizationId,dispatcher)}

    console.log('Response from MongoDB:', response.data.message);

    return response.data;
  } catch (error:any) {
    console.error('Error fetching resources:', error.message);
    // throw new Error(error.message);
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
    close();
    // {reload!==false &&
    // setTimeout(() => {
    //   window.location.reload();
    // }, 1000);}
  }
};

export const deleteResourceMongo = async (
  organizationId: string,
  resourceType:String,
  Id:string,
  dispatcher:any,
  setLoad: (data: boolean) => void,
  close: () => void,
  authToken?: string,
): Promise<any> => {
  try {

    const apiData:{ [key: string]: any }={
      organization_id:organizationId,
      resource_type:resourceType,
      Id:Id
    }

    // console.log("apiData",apiData)
    // Set the default header for axios
    // if (authToken) {
    //   axios.defaults.headers.common['x-access-token'] = authToken;
    // }
    // Fetch resources
    const response = await axiosHandler.post(`${url}/organizationResources/deleteresource`,apiData);
    dispatcher(showSnackbarAction(response.data.message, 'error'));
    setLoad(false);
    // close();

    setTimeout(() => {
      window.location.reload();
    }, 1000);

    // console.log('Response from MongoDB:', response.data.message);

    return response.data;
  } catch (error:any) {
    // console.error('Error fetching resources:', error.message);
    // throw new Error(error.message);
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
    close();
  }
};


export const editResourceMongo = async (
  Id:string,
  organizationId: string,
  resourceType:String,
  resourceObj:any,
  dispatcher:any,
  setLoad: (data: boolean) => void,
  close: () => void,
  authToken?: string,
): Promise<any> => {
  try {
    const apiData:{ [key: string]: any }={
      Id:Id,
      // organization_id:organizationId,
      resource_type:resourceType,
      [resourceType as string]:resourceObj ,
    }

    // console.log("apiData",apiData)
    // Set the default header for axios
    // if (authToken) {
    //   axios.defaults.headers.common['x-access-token'] = authToken;
    // }
    // Fetch resources
    const response = await axiosHandler.put(`${url}/organizationResources/updateOrg`,apiData);
    dispatcher(showSnackbarAction(response.data.message, 'success'));
    setLoad(false);
    close();

    setTimeout(() => {
      window.location.reload();
    }, 1000);

    // console.log('Response from MongoDB:', response.data.message);

    return response.data;
  } catch (error:any) {
    // console.error('Error fetching resources:', error.message);
    // throw new Error(error.message);
    dispatcher(
      showSnackbarAction(error.response.data.message, "error")
    );
    setLoad(false);
    close();
    // setTimeout(() => {
    //   window.location.reload();
    // }, 1000);
  }
};

export const fetchOrgResMongo= async(
  // authToken:any,
  organizationId:any,
  dispatcher:any,

)=>{
  try {
    // if (authToken) {
    //   axios.defaults.headers.common['x-access-token'] = authToken;
    // }

    // Fetch resources
    const response = await axiosHandler.get(`${url}/organizationResources/fetchAll`, {
      params: { organization_id: organizationId },
    });

    if(response){
      dispatcher(setOrganizationResources(response.data.data))
    }
    else{
      dispatcher(setOrganizationResources([]))
    }
  } catch (error:any) {
    dispatcher(setOrganizationResources([]))
    console.log("organization resource setting in redux giving error",error.message)
  }
}


export const setMBStaticConstants = async (
  dispatcher: any
) => {
  try {
    let states=[]
    let budget:any=[]
    let residential:any=[]
    let commercial:any=[]
    let buyBudget:any=[]
    let rentBudget:any=[]
    const res: any = await axiosHandler.post(url + "/constants/fetchDbConstants",{
      "type":["BUDGET_CONST","PROPERTY_TYPE","STATES",'BUY_BUDGET','RENT_BUDGET']
    });
    if (res) {
      res.data.data[0].data.forEach((element:any) => {
        budget.push(element.displayName)
      });
      res.data.data[1].data.forEach((element:any) => {
        if(element.propertyType === "Commercial"){
          commercial=element.subType
        }
        if(element.propertyType === "Residential"){
          residential=element.subType
        }
      });
      states=res?.data?.data[2]?.data
      res?.data?.data[3]?.data?.forEach((element:any) => {
        buyBudget.push(element)
      });
      res?.data?.data[4]?.data?.forEach((element:any) => {
        rentBudget.push(element)
      });
      dispatcher(setMBConstants({
        states:states,
        budget:budget,
        residential:residential,
        commercial:commercial,
        buyBudget:buyBudget,
        rentBudget:rentBudget
      }));
    }
  } catch (error) {
    console.log("error",error)
  }
}

export const getLocationData = async (textEnter: any,DropDownClicked:any) => {
  try {
    let payloadType = ''
    if(DropDownClicked === "LOCATION"){
      payloadType ="locality"
    }
    else if(DropDownClicked === "PROJECT"){
      payloadType='mb'
    }
    const res: any = await axiosHandler.get(
      url + "/constants/autoSuggest",
      {
        params:  {
          type: payloadType,
          text:textEnter
        }
      }
    );

    let apiLocation:any = []

    if(res?.data?.success === true && res?.data?.data?.length >0){
      res?.data?.data.forEach((element:any) => {
      apiLocation.push(element.result)
      });
    }
    return apiLocation;
  } catch (err) {
    console.log("err fetching location", err);
    return []
  }
}